import * as React from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import styles from './styles.module.scss';
import Icon from '@/components/ui/Icon';

export interface IHeadingWithToolsProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  prefix?: React.ReactNode;
  addOn?: React.ReactNode;
  badge?: {
    url: string;
    alt: string;
  };
  level?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  layout?: 'default' | 'centered' | 'hero' | 'pool';
  className?: string;
  effects?: {
    circles?: boolean;
    imageUrl?: string;
  };
  id?: string;
}

const HeadingWithTools: React.FunctionComponent<IHeadingWithToolsProps> = (props) => {
  let Elem: keyof React.JSX.IntrinsicElements = 'h2';
  if (props.level) {
    Elem = props.level;
  }

  return (
    <React.Fragment>
      {props.effects && (
        <div className={styles['heading-with-tools__effects']}>
          {props.effects.circles && (
            <Icon
              width={132}
              height={132}
              kind="effect-circles"
              className={styles['heading-with-tools__effects__circles']}
            />
          )}
          {props.effects.imageUrl && (
            <div className={styles['heading-with-tools__effects__image']}>
              <Image
                src={props.effects.imageUrl}
                fill={true}
                sizes="200px"
                alt=""
              />
            </div>
          )}
        </div>
      )}
      <div
        id={props.id}
        className={classNames(
          styles['heading-with-tools'],
          {
            [styles['layout-centered']]: props.layout === 'centered',
            [styles['layout-hero']]: props.layout === 'hero',
            [styles['layout-pool']]: props.layout === 'pool',
          },
          props.className,
        )}
      >
        <div className={styles['heading-with-tools__main']}>
          {props.prefix && <div className={styles['heading-with-tools__prefix']}>{props.prefix}</div>}
          <div className={styles['heading-with-tools__title']}>
            {props.badge && (
              <Image
                src={props.badge.url}
                alt={props.badge.alt}
                width={54}
                height={54}
              />
            )}
            <Elem className={styles['heading-with-tools__title__element']}>{props.title}</Elem>
          </div>
          {props.description && <div className={styles['heading-with-tools__title__description']}>{props.description}</div>}
        </div>
        {props.addOn && <div className={styles['heading-with-tools__addon']}>{props.addOn}</div>}
      </div>
    </React.Fragment>
  );
};

HeadingWithTools.displayName = 'HeadingWithTools';

export default HeadingWithTools;
